'use client';

import { useParams } from 'next/navigation';
import { useGetEcosystemGroupsQuery } from '@/services/ecoType/queries';

// Các section import (giữ nguyên)
import BannerSectionFourth from '@/components/layouts/EcoSystemSections/RoviCompanyFourth/BannerSectionFourth';
import AboutInvestmentSection from '@/components/layouts/EcoSystemSections/RoviCompanyFourth/AboutInvestment';
import DetailsInvestment from '@/components/layouts/EcoSystemSections/RoviCompanyFourth/DetailsInvestment';
import FeaturedProjects from '@/components/layouts/EcoSystemSections/RoviCompanyFourth/FeaturedProjects';
import Footer from '@/components/layouts/Footer';
import Differences from '@/components/layouts/EcoSystemSections/RoviCompanyFourth/Differences';
import PartnersSection from '@/components/layouts/EcoSystemSections/RoviCompanyFourth/Partner';
import RoviArticles from '@/components/layouts/EcoSystemSections/RoviCompanyFourth/RoviArticles';
import BannerSectionFisrt from '@/components/layouts/EcoSystemSections/RoviCompanyFirst/BannerSectionFisrt';
import AboutTravelSection from '@/components/layouts/EcoSystemSections/RoviCompanyFirst/AboutTravel';
import DetailsTravel from '@/components/layouts/EcoSystemSections/RoviCompanyFirst/DetailsTravel';
import BannerSectionSecond from '@/components/layouts/EcoSystemSections/RoviCompanySecond/BannerSectionSecond';
import AboutHospitalitySection from '@/components/layouts/EcoSystemSections/RoviCompanySecond/AboutHospitality';
import DetailsHospitality from '@/components/layouts/EcoSystemSections/RoviCompanySecond/DetailsHospitality';
import BannerSectionThird from '@/components/layouts/EcoSystemSections/RoviCompanyThird/BannerSectionThird';
import AboutLogisticSection from '@/components/layouts/EcoSystemSections/RoviCompanyThird/AboutLogistic';
import DetailsLogistic from '@/components/layouts/EcoSystemSections/RoviCompanyThird/DetailsLogistic';

export default function EcosystemDetailPage() {
    const params = useParams();
    // urlSlug lúc này sẽ là: "rovi-investment" hoặc "rovi-travel"
    const urlSlug = params.id as string;

    // 1. Lấy danh sách tất cả các công ty
    const { data: groups = [], isLoading: groupsLoading } = useGetEcosystemGroupsQuery();


    const createSlug = (title: string) => {
        return title.toLowerCase()
            .replace(/\(rvh\)/g, '')
            .trim()
            .replace(/[áàảãạăắằẳẵặâấầẩẫậ]/g, 'a')
            .replace(/[éèẻẽẹêếềểễệ]/g, 'e')
            .replace(/[iíìỉĩị]/g, 'i')
            .replace(/[óòỏõọôốồổỗộơớờởỡợ]/g, 'o')
            .replace(/[úùủũụưứừửữự]/g, 'u')
            .replace(/[ýỳỷỹỵ]/g, 'y')
            .replace(/đ/g, 'd')
            .replace(/[^a-z0-9-]/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '');
    };

    // 3. Tìm công ty có tên khớp với URL
    const company = groups.find((g) => createSlug(g.title) === urlSlug);

    // Trạng thái tải
    if (groupsLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-white">
                <div className="text-xl text-gray-600">Đang tải thông tin...</div>
            </div>
        );
    }

    // Không tìm thấy
    if (!company) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-white">
                <div className="text-center">
                    <h1 className="text-4xl font-bold text-gray-800 mb-4">Không tìm thấy</h1>
                    <p className="text-lg text-gray-600">
                        Không tìm thấy hệ sinh thái: <strong>{urlSlug}</strong>
                    </p>
                </div>
            </div>
        );
    }

    // 4. Lấy ID thật từ công ty tìm được để truyền xuống component con
    const realId = company.id;

    const renderSections = () => {
        // Dùng slug để check loại công ty cho chính xác
        const currentSlug = createSlug(company.title);

        // Investment
        if (currentSlug.includes('investment') || currentSlug.includes('dau-tu')) {
            return (
                <>
                    <BannerSectionFourth />
                    {/* Vẫn truyền ID số xuống dưới */}
                    <AboutInvestmentSection companyId={realId} />
                    <DetailsInvestment companyId={realId} />
                    <Differences companyId={realId} />
                    <FeaturedProjects companyId={realId} />
                    <PartnersSection companyId={realId} />
                    <RoviArticles companyId={realId} />
                    <Footer />
                </>
            );
        }

        // Travel
        if (currentSlug.includes('travel') || currentSlug.includes('du-lich')) {
            return (
                <>
                    <BannerSectionFisrt />
                    <AboutInvestmentSection companyId={realId} />
                    <DetailsInvestment companyId={realId} />
                    <Differences companyId={realId} />
                    <FeaturedProjects companyId={realId} />
                    {/* <DifferencesTravel /> */}
                    <PartnersSection companyId={realId} />
                    <RoviArticles companyId={realId} />
                    <Footer />
                </>
            );
        }

        // Hospitality
        if (currentSlug.includes('hospitality') || currentSlug.includes('khach-san') || currentSlug.includes('nha-hang')) {
            return (
                <>
                    <BannerSectionSecond />
                    <AboutInvestmentSection companyId={realId} />
                    <DetailsInvestment companyId={realId} />
                    <Differences companyId={realId} />
                    <FeaturedProjects companyId={realId} />
                    <PartnersSection companyId={realId} />
                    <RoviArticles companyId={realId} />
                    <Footer />
                </>
            );
        }

        // Logistics
        if (currentSlug.includes('logistics') || currentSlug.includes('van-tai')) {
            return (
                <>
                    <BannerSectionThird />
                    <AboutInvestmentSection companyId={realId} />
                    <DetailsInvestment companyId={realId} />
                    <Differences companyId={realId} />
                    <FeaturedProjects companyId={realId} />
                    <PartnersSection companyId={realId} />
                    <RoviArticles companyId={realId} />
                    <Footer />
                </>
            );
        }

    };

    return <div className="bg-white dark:bg-white min-h-screen">{renderSections()}</div>;
}